export const queryKeys = {
  admin: {
    list: (resource: string, params: Record<string, unknown>) =>
      ["admin", resource, "list", params] as const,
    detail: (resource: string, id: string | number) => ["admin", resource, id] as const,
  },
  auth: {
    me: ["auth", "me"] as const,
  },
} as const;
